import React, { useState } from 'react';
import styles from './header.module.css';
import { Menu } from './menu/Menu';
import { MarkupLayout } from '../../ui/markupLayout/MarkupLayout';
import { Phone } from '../../ui/phone/Phone';
import { Telegram } from '../../ui/telegram/Telegram';
import { Link, NavLink } from 'react-router';
import { useUserStore } from '../../../stores/useUserStore';

export function Header() {

  const { user } = useUserStore()

  const links = [
    {
      text: 'Автомобильные фильтры',
      to: '/car-filters',
    },
    {
      text: 'Тормозные колодки',
      to: '/brake-pads',
    },
    {
      text: 'Щетки стеклоочистителя',
      to: '/wiper-blades',
    },
    {
      text: 'Каталог',
      to: '/catalog',
    },
    {
      text: 'О нас',
      to: '/about-us',
    },
    {
      text: 'Контакты',
      to: '/contacts',
    },
  ];

  const [menuActiv, setMenuActive] = useState(false);

  return (
    <header>
      <nav className={styles.nav}>
        <MarkupLayout>
          <div className={styles.nav_container}>
            <Link to={"/"}>
              <img className={styles.nav_logo} src="images/logo.webp" alt="logo" />
            </Link>
            <div className={styles.holder}>
              <div className={styles.contacts}>
                <div className={styles.header__contacts_icons}>

                  <Phone color={`dark-blue-sct`} />
                  <Telegram color={`dark-blue-sct`} />

                </div>

                <div className={styles.contacts__container}>
                  {/* <SearchIcon /> */}

                  <div className={`${styles.contacts__container_item}   ${styles.phone}`}>
                    <a href="tel:+74992882648">+7 499 288-26-48</a>
                  </div>
                  <div className={styles.contacts__container_item}>
                    <a href="mailto:info@sct-germany.ru">info@sct-germany.ru</a>{' '}
                  </div>
                  {/* {user ? <NavLink to={"/profile"}>  Личный кабинет </NavLink> : <NavLink to={"/login"}>Вход</NavLink>} */}

                </div>

                <div
                  className={`${styles.burger_btn} ${menuActiv ? styles.open : ''}`}
                  onClick={() => setMenuActive(!menuActiv)}
                >
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>

              <div className={styles.nav_links_wrapper}>
                {links.map((item) => {
                  return (
                    <NavLink
                      key={item.text}
                      to={item.to}
                      style={({ isActive }) => ({
                        color: isActive ? '#fcc71e' : '',
                      })}
                    >
                      {item.text}
                    </NavLink>
                  );
                })}
              </div>
            </div>
          </div>
        </MarkupLayout>
        <Menu active={menuActiv} setMenuActive={setMenuActive} items={links} />
      </nav>
    </header>
  );
}
